import { getData, deleteData, postData } from "../apiClient";

const ItemName = "Check Out";
const API_URL = "room-checkout";

export const getAllChecInRoom = async (signal = null) => {
  try {
    const result = await getData(`/${API_URL}/`, {}, {}, signal);
    return {
      success: true,
      data: result,
    };
  } catch (error) {
    console.error("Get Booking Types API error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// get item data with id
export const Search = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.data.message || error.data.error,
      },
    };
  }
};

// get item data with id

export const GetInvoiceById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/invoice/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetParKingBillByID = async ({
  customer_id,
  check_in_date,
  check_out_date,
}) => {
  try {
    const result = await postData(
      `/${API_URL}/car-parking-booking/${customer_id}`,
      { check_in_date, check_out_date },
    );
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetPoolBookingBillByID = async ({
  customer_id,
  check_in_date,
  check_out_date,
}) => {
  try {
    const result = await postData(`/${API_URL}/pool-booking/${customer_id}`, {
      check_in_date,
      check_out_date,
    });
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetTransportVehicleBillByID = async ({
  customer_id,
  check_in_date,
  check_out_date,
}) => {
  try {
    const result = await postData(
      `/${API_URL}/transport-vehicle-booking/${customer_id}`,
      { check_in_date, check_out_date },
    );
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const getAllPaymentMethods = async () => {
  try {
    const result = await getData(`/${API_URL}/all/payment-methods`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const Update = async ({ id, data }) => {
  try {
    const result = await postData(`/${API_URL}/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update user API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const DeleteParking = async ({ id }) => {
  try {
    const result = await deleteData(`/${API_URL}/car-parking-booking/${id}`);
    return { data: { success: true, data: result } };
  } catch (error) {
    return { data: { success: false, error: error.message } };
  }
};

export const DeletePoolbooking = async ({ id }) => {
  try {
    const result = await deleteData(`/${API_URL}/delete-pool-booking/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Delete ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const DeleteTransport = async ({ id }) => {
  try {
    const result = await deleteData(
      `/${API_URL}/transport-vehicle-booking/${id}`,
    );
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Delete ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetAll = async (signal = null, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();

    const result = await getData(
      `/${API_URL}/today/?${queryString}`,
      {},
      {},
      signal
    );

    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} API error:`, error);

    return {
      success: false,
      ...error,
    };
  }
};

export const BulkCheckout = async (bookingIds, signal = null) => {
  try {
    const result = await postData(
      `/${API_URL}/bulk/checkout`,
      { booking_ids: bookingIds },
      {},
      signal,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Bulk Checkout API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};
